const features = [
  {
    icon: 'ri-map-pin-2-line',
    title: 'Vamos Até Você',
    description: 'Atendimento a domicílio em João Pessoa e região. Sem precisar sair de casa ou da empresa.',
  },
  {
    icon: 'ri-time-line',
    title: 'Atendimento Rápido',
    description: 'Diagnóstico ágil e solução eficiente. Resposta em até 24 horas para todos os chamados.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Garantia no Serviço',
    description: 'Todos os serviços realizados com garantia. Sua satisfação é nossa prioridade.',
  },
  {
    icon: 'ri-building-line',
    title: 'Pessoa Física e Jurídica',
    description: 'Atendemos residências e empresas com soluções personalizadas para cada necessidade.',
  },
  {
    icon: 'ri-price-tag-3-line',
    title: 'Preço Justo',
    description: 'Orçamento transparente e sem surpresas. Qualidade profissional com preço acessível.',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Suporte Contínuo',
    description: 'Suporte remoto disponível para dúvidas e problemas mesmo após o atendimento presencial.',
  },
];

export default function WhyUs() {
  return (
    <section className="py-16 md:py-24 bg-[#f0faf8]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-center">
          {/* Left */}
          <div>
            <div className="inline-flex items-center gap-2 text-[#00c9a7] text-xs font-semibold uppercase tracking-widest mb-4">
              <span className="w-8 h-px bg-[#00c9a7]" />
              Por que nos escolher
            </div>
            <h2 className="text-2xl md:text-4xl font-bold text-[#0d1b2a] mb-5 md:mb-6 leading-tight">
              Tecnologia com Confiança e Atendimento Humanizado
            </h2>
            <p className="text-gray-500 text-sm md:text-base leading-relaxed mb-6 md:mb-8">
              A JampaBit nasceu para oferecer suporte técnico de qualidade com o cuidado que você merece. Somos especialistas em informática com anos de experiência atendendo clientes residenciais e empresariais em João Pessoa.
            </p>
            <a
              href="https://wa.me/5583991755663?text=Olá!%20Gostaria%20de%20solicitar%20um%20orçamento."
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center gap-2 bg-[#00c9a7] hover:bg-[#00b396] text-white font-semibold px-7 py-3.5 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-sm md:text-base"
            >
              <i className="ri-whatsapp-line" />
              Solicitar Orçamento
            </a>
          </div>

          {/* Right - Features Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {features.map((f) => (
              <div
                key={f.title}
                className="bg-white rounded-2xl p-4 md:p-5 border border-gray-100 hover:border-[#00c9a7]/30 transition-all duration-200"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#1a3a4a] mb-3 md:mb-4">
                  <i className={`${f.icon} text-[#00c9a7] text-lg`} />
                </div>
                <h3 className="text-[#0d1b2a] font-bold text-sm mb-1.5 md:mb-2">{f.title}</h3>
                <p className="text-gray-500 text-xs leading-relaxed">{f.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
